module.exports = __webpack_public_path__ + "static/wiz7-40def812a90c332daa7907363efdace5.jpg";